module.exports = __webpack_public_path__ + "static/img/male2-01.5ebbfd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/male2-01.jpg
// module id = 274
// module chunks = 1